import { Component, OnInit, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { PqsAdminService } from 'src/app/servicios/pqs-admin.service';
import { Subject } from 'rxjs';
import { DTConfig } from 'src/app/Class/DTConfig ';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import Swal from 'sweetalert2';
import { Loading } from 'src/app/Class/Loading';
import { UserService } from 'src/app/servicios/user.service';
import { PqrsFacultadesService } from 'src/app/servicios/pqrs-facultades.service';
declare var $: any;

@Component({
  selector: 'app-listado-pqrs',
  templateUrl: './listado-pqrs.component.html',
  styleUrls: ['./listado-pqrs.component.css']
})
export class ListadoPQRSComponent implements OnInit, OnDestroy {

  public dtOptions: DataTables.Settings[] = [ DTConfig.dtConf, DTConfig.dtConf, DTConfig.dtConf ];
  public dtTrigger: Subject<any> = new Subject();
  index: number;
  public errores = [];
  public server = '';
  Toast = Swal.mixin({ toast: true, position: 'top-end', showConfirmButton: false, timer: 3000 });
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;

  public formAsignacion: FormGroup;
  public formRespuesta: FormGroup;
  public formEditarPqrs: FormGroup;
  public formDevolucion: FormGroup;
  public listadoNuevas: any = [];
  public listadoAsignadas: any = [];
  public listadoDevueltas: any = [];
  
  public facultades: any = [];
  public tipoCaso: any = [];
  public unidades: any = [];
  public personas: any = [];
  public detalles: any = { documentos : [], documentosRespuesta:[] };
  public selectFacultad: any = { programas: [] };
  public rechazar: any = {};
  public descriptores: any = [];
  public rol: any;

  constructor(private servi: PqsAdminService, private fb: FormBuilder, public loading: Loading, private user:UserService, private serviFacultad: PqrsFacultadesService) {
    this.getListado(false);

    this.server = servi.getServe();

    this.formAsignacion = this.fb.group({
      id_solicitud : ['', Validators.required],
      tipo_unidad: ['', Validators.required],
      id_unidad: ['', Validators.required],
      observaciones: [''],
      descriptores_selected: ['']
    });

    this.formRespuesta = this.fb.group({
      id_solicitud: ['', Validators.required],
      observaciones: ['', Validators.required],
      archivo: [],
     });

    this.formEditarPqrs = this.fb.group({
      id: ['', Validators.required],
      idTipoCaso: [, Validators.required],
      descriptores_selected: ['', ]
     });

     this.rol = user;
  }

  ngOnInit(): void {}

  ngOnDestroy(): void { this.dtTrigger.unsubscribe(); }

  addTagPalabra(nombre) { return { nombre: nombre, tag: true }; }

  openModalDetalles(item, index) 
  {
    this.loading.estado = true;
    this.index = index;

    this.servi.getDetalle(item.id)
    .subscribe(data => {
      this.detalles = data;
      $('#ModaldetalleSolicitud').modal('show');
      this.loading.estado = false;
    });
  }

  openModalAsinar(item, index) {
    this.index = index;
    $('.modal').modal('hide');
    this.formAsignacion.reset({ id_solicitud: item.id });
    this.detalles = item;    
    this.selectFacultad = { programas: [] };
    //debugger;
    if(item.programaId != null && item.programaId > 0){
      this.formAsignacion.get("tipo_unidad").setValue(2);
      this.selectFacultad = this.facultades.filter(row=>row.id == item.facultadId)[0];
      this.formAsignacion.get("id_unidad").setValue(item.programaId);
    }else if(item.facultadId != null && item.facultadId > 0){
      this.formAsignacion.get("tipo_unidad").setValue(1);
      this.formAsignacion.get("id_unidad").setValue(item.facultadId);
      this.selectFacultad = this.facultades.filter(row=>row.id == item.facultadId)[0];
    }
    $('#ModalAsignarSolicitud').modal('show');
  }

  openModalRechazar(item, index) {
    this.index = index;
    $('.modal').modal('hide');
    this.rechazar = { id_solicitud: item.id };
    this.detalles = item;
    $('#ModalRechazarSolicitud').modal('show');
  }

  openModalResponder(item, index) {
    this.index = index;
    $('.modal').modal('hide');
    this.formRespuesta.reset({ id_solicitud: item.id });
    this.detalles = item;
    $('#ModalResponderSolicitud').modal('show');
  }

  editarPqrs( datos, index ) {
    this.index = index;
    $('.modal').modal('hide');
    // tslint:disable-next-line: forin
    for ( const atributos  in this.formEditarPqrs.value) {
      this.formEditarPqrs.get(atributos).setValue(datos[atributos]);
    }
    this.detalles = datos;
    $('#ModalEditarPqrs').modal({ backdrop: 'static', keyboard: true, show: true });
  }

  guardarAsignacion() {

    if ( !this.formAsignacion.valid ) { return; }

    this.loading.estado = true;

    this.servi.asignarUnidad(this.formAsignacion.value)
    .subscribe(data => {
      if (data['success']) {
          this.listadoNuevas.splice(this.index, 1);
          this.listadoAsignadas = data['solicitudesAsiganadas'];
          $('.modal').modal('hide');
          this.Toast.fire({ type: 'success', title: 'Solicitud asignada exitosamente' });
          this.rerender();
      } else {
        this.errores = data['errores'];
      }

      this.loading.estado = false;

    });
  }

  guardarEdicion() 
  {

    this.loading.estado = true;
    this.servi.editarSolicitud(this.formEditarPqrs.value)
    .subscribe( data => {
      if (data ['success']) {
        this.listadoNuevas = data['solicitudesNuevas'];
        $('.modal').modal('hide');
        this.Toast.fire({ type: 'success', title: 'Respuesta enviada exitosamente' });
        this.rerender();
      } else {
        this.errores = data['errores'];
      }

      this.loading.estado = false;

    });
  }

  guardarRechazar() {

    if ( !this.rechazar.id_solicitud || !this.rechazar.observaciones ) { return; }

    this.loading.estado = true;

    this.servi.rechazarSolicitud(this.rechazar)
    .subscribe(data => {
      if (data['success']) {
          this.listadoNuevas.splice(this.index, 1); 
          $('.modal').modal('hide');
          this.Toast.fire({ type: 'success', title: 'Solicitud rechazada exitosamente' });
          this.rerender();
      } else {
        this.errores = data['errores'];
      }

      this.loading.estado = false;

    });
  }

  guardarRespuesta() 
  {
    this.loading.estado = true;

    this.servi.responderSolicitud(this.formRespuesta.value)
    .subscribe( data => {
      if (data ['success']) {
        this.listadoNuevas = data['solicitudesNuevas'],
        $('.modal').modal('hide');
        this.Toast.fire({ type: 'success', title: 'Respuesta enviada exitosamente' });
        this.rerender();
      } else {
        this.errores = data['errores'];
      }
      this.loading.estado = false;
    });
  }

  getListado(render) {
    this.loading.estado = true;
    this.servi.getListado().subscribe(data => {
       this.listadoNuevas = data['solicitudesNuevas'].length > 0 ? data['solicitudesNuevas'] : [] ,
       this.listadoAsignadas = data['solicitudesAsiganadas'].length > 0 ? data['solicitudesAsiganadas'] : [],
       this.listadoDevueltas = data['solicitudesDevueltas'].length > 0 ? data['solicitudesDevueltas'] : [],
       this.facultades = data['facultades'],
       this.unidades = data['unidades'],
       this.personas = data['personas'],
       this.tipoCaso = data['tipoCaso'],
       this.descriptores = data['descriptores'];

       if (render) {
          this.Toast.fire({ type: 'success', title: 'Listados actualizados exitosamente' });
          this.rerender();
        }
       this.dtTrigger.next();
       this.loading.estado = false;
      });
  }

  rerender(): void {
    this.dtElements.forEach((dtElement: DataTableDirective) => {
      dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
    });
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
    const file = event.target.files[0];
    this.formRespuesta.get('archivo').setValue(file);
  }
  }

  openModalDevolver(item, index) {
    this.index = index;
    $('.modal').modal('hide');
    this.formDevolucion.reset({ id_solicitud: item.id });
    this.detalles = item;
    $('#ModalDevolverSolicitud').modal('show');
  }

  guardarDevolucion() 
  {

    this.loading.estado = true;

    this.serviFacultad.devolverSolicitud(this.formDevolucion.value).subscribe( data => {
      if (data ['success']) {
        this.listadoNuevas.splice(this.index, 1);
        $('.modal').modal('hide');
        this.Toast.fire({ type: 'success', title: 'Solicitud devuelta exitosamente' });
        this.rerender();
      } else {
        this.errores = data['errores'];
      }

      this.loading.estado = false;

    });
  }

}
